import { errorLoading, responseHandler, errorGetStatus, tokenInterceptor } from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

export const localeWS = (state = {locales: []}, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.LOCALES.FETCH_LOCALES:
      return Object.assign({}, state, { locales: action.datas })
    default:
      return state
  }
}

export const setLocales = (data) => {
  return {
    type: Constants.ActionsConstants.LOCALES.FETCH_LOCALES,
    datas: data,
  }
}

export function fetchLocalesAction (dispatch) {
  function fetchLocales () {
    let entryPoint = Constants.UrlsConstants.localeEntryPoint
    let method = Constants.MethodsWSConstants.LOCALE.FETCH_LOCALES
    fetch(urlServer+entryPoint+method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header})
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      dispatch(setLocales(data))
    })
    .catch(error => {
      // dispatch(errorLoading(method))
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
        // window.location.href='/'
      }
    })
  }

  return {
    fetchLocales,
  }
}
